import { ParallaxBackground } from "@/ui/ParallaxBackground";
import cn from "classnames";
import { Container } from "react-bootstrap";
import { Quote } from "@/ui/Quote";
import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import bg_sm from "./bg_sm.webp";
import QuoteMarkEndIcon from "./QuoteMarkEnd.svg";
import QuoteMarkStartIcon from "./QuoteMarkStart.svg";
import classes from "./styles.module.scss";

export default function ({ className = "py-6 py-md-7", quote, cite, role, EditableText }) {
  return (
    <div className={cn(className, classes.BlockQuote)}>
      {quote.length > 500 ? (
        <>
          <ParallaxBackground
            anim="y1:x0:z0"
            image={bg_1}
            floating={false}
            className={classes.bg_1}
          />
          <ParallaxBackground
            anim="y1:x0:z0"
            image={bg_2}
            floating={false}
            className={classes.bg_2}
          />
        </>
      ) : (
        <ParallaxBackground anim="y1:x1n:z0" image={bg_sm} className={classes.bg_sm} />
      )}
      <Container>
        <blockquote className="px-5">
          <img className="svg" src={QuoteMarkStartIcon} alt="" />
          <img className="svg" src={QuoteMarkEndIcon} alt="" />
          <Quote as={EditableText} path="Quote" >
          <div className="mb-4" dangerouslySetInnerHTML={{ __html: quote }} />
          <cite>
            {cite} <br />
            <span>{role}</span>
          </cite>
          </Quote>
        </blockquote>
      </Container>
    </div>
  );
}
